import { createStore } from 'satcheljs';
export default createStore('surfaceActionsOption', {
    readSurfaceActions: null,
    readSurfaceAddins: null,
    composeSurfaceActions: null,
    composeSurfaceAddins: null,
})();
//# sourceMappingURL=store.js.map